import { StyleSheet, Text, View } from '../base_components';
import BusyComponent from '../busy_component';
import QRCode from 'qrcode.react';

import CryptoStore from '../../stores/crypto_store';

import CloseButton from '../buttons/close_button';
import WideButton from '../buttons/wide_button';
import ModalDialog from '../dialogs/modal_dialog';

declare var React: any;

const styles = StyleSheet.create({
  cryptoInOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.95)',

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  close: {
    position: 'absolute',
    top: '1em',
    right: '1em',
    height: '3em',
    width: '3em',
  },
  titleText: {
    marginLeft: '2em',
    marginRight: '2em',
    marginBottom: '1em',
    maxWidth: '30em',
    color: 'white',
    fontSize: '1em',
    textAlign: 'center',
  },
  stepWrapper: {
    width: '30em',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  stepText: {
    marginTop: '1em',
    color: 'white',
    fontSize: '1em',
  },
  subText: {
    margin: '2em',
    maxWidth: '30em',
    color: 'white',
    fontSize: '1em',
    textAlign: 'center',
  },
  addrText: {
    marginBottom: '2em',
    color: 'white',
    fontSize: '1.1em',
    fontFamily: 'monospace',
    userSelect: 'all',
    '-webkit-tap-highlight-color': 'white',
    '-webkit-touch-callout': 'default',
  },
  box: {
    padding: '1em',
    backgroundColor: 'white',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

type Props = {
  onDone: () => void;
};
type State = {
  dest_addr?: string;
};

const CONTRACT = '0xf220aF718A8d13CCE7f5A466722F2b5857cd4215';

export default class CryptoInOverlay extends BusyComponent<Props, State> {
  state = {
    dest_addr: null,
  };
  _onGetPress = () => {
    if (this.setBusy()) {
      CryptoStore.fetchDestAddr((err, dest_addr) => {
        this.clearBusy();
        if (err) {
          ModalDialog.error(
            'Failed to get Destination Address, please try again.'
          );
        } else {
          this.setState({ dest_addr });
        }
      });
    }
  };

  render() {
    const { onDone } = this.props;
    const { dest_addr } = this.state;

    let address = null;
    if (dest_addr) {
      const url = `ethereum:${CONTRACT}/transfer?address=${dest_addr}`;
      address = (
        <>
          <Text style={styles.titleText}>Destination Address:</Text>
          <Text style={styles.addrText}>{dest_addr}</Text>
          <View style={styles.box}>
            <QRCode value={url} size={128} />
          </View>
        </>
      );
    } else {
      address = <WideButton text='Get Address' onPress={this._onGetPress} />;
    }

    return (
      <View style={styles.cryptoInOverlay}>
        <Text style={styles.titleText}>
          Transfer Dank Coin into your DankCoin.net account in 4 easy steps.
        </Text>
        <View style={styles.stepWrapper}>
          <Text style={styles.stepText}>
            1. Get a DankCoin.net destination address.
          </Text>
          <Text style={styles.stepText}>
            2. Scan or copy the address to your Crypto Wallet.
          </Text>
          <Text style={styles.stepText}>
            3. Transfer Dank Coins to your DankCoin.net.
          </Text>
          <Text style={styles.stepText}>4. Profit!</Text>
        </View>
        <Text style={styles.subText}>
          Note: Incoming transfers can take up to 10 minutes to show up in your
          DankCoin.net balance.
        </Text>
        {address}
        <CloseButton style={styles.close} onPress={onDone} />
        <BusyComponent.BusyOverlay isBusy={this.state.is_busy} />
      </View>
    );
  }
}
